/** Format and caption helpers for Product Analyzer demand / revenue estimates. */

export function formatUnitsRange(low, high, numFn) {
  if (low == null || high == null) return "—";
  return `${numFn(low)}–${numFn(high)}`;
}

export function formatMoneyRange(low, high, usdFn) {
  if (low == null || high == null) return "—";
  return `${usdFn(low)}–${usdFn(high)}`;
}

export function demandTooltip(estimate) {
  if (!estimate?.available) {
    return "Demand estimate unavailable — Walmart did not provide enough signals to model sales safely.";
  }
  if (estimate.basis === "walmart_purchase_activity_daily_extrapolation") {
    const src = estimate.source_text || "purchase activity";
    return `Estimated from Walmart’s “${src}” message, extrapolated across 30 days. This is not verified unit sales.`;
  }
  if (estimate.basis === "walmart_purchase_activity_monthly") {
    const src = estimate.source_text || "purchase activity";
    return `Estimated from Walmart’s “${src}” message for the past month. This is a lower-bound range, not verified unit sales.`;
  }
  if (estimate.basis === "category_demand_model") {
    return "Modeled from product category and available listing signals. Walmart does not publish exact product sales for this estimate.";
  }
  return "Estimated monthly sales. This is not verified Walmart unit sales.";
}

export function revenueTooltip(revenue, demand) {
  if (!revenue?.available) {
    if (revenue?.reason === "price_unavailable") {
      return "Estimated monthly revenue unavailable — current price is missing.";
    }
    return "Estimated monthly revenue unavailable — demand estimate is missing.";
  }
  return `Estimated monthly revenue = estimated units × current price. ${demandTooltip(demand)} Never treated as actual Walmart revenue.`;
}
